<template>
	<CommonLoading
		v-if="loading"
	/>
	<iframe width="600" height="450" src="https://lookerstudio.google.com/embed/reporting/7924beff-cab4-435a-96ed-bbdb49549af7/page/CUCLF" frameborder="0" style="border:0" allowfullscreen></iframe>
</template>

<script>

import AgendamentosRepository from "@/services/AgendamentosRepository";
import GruposRepository from '@/services/GruposRepository.vue';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import CommonLoading from "@/components/generalcomponents/CommonLoading.vue";

export default {
	name: "UsuarioDashView",
	components: {
		CommonLoading
	},
	data() {
		return {
			loading: false,
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			agendamentos: [],
			agendadores: [],
			stats: {
				total_pendentes: 0,
				total_nao_pendentes: 0,
				total_atrasados: 0,
			},
			filters: {
				responsavel_email: "",
				data_inicio: "",
				data_fim: "",
				agendador_email: "",
			},
			chartOptions: {
				chart: {
					type: "bar",
				},
				xaxis: {
					categories: [],
				},
			},
			chartSeries: [
				{
					name: "Agendamentos por Agendador",
					data: [],
				},
			],
			agendadoresPage: process.env.VUE_APP_API_URL + "get-group-members/agendadores",
			gerencialPage: process.env.VUE_APP_API_URL + "agendamentos/gerencial",
			headerInfo: {
				"title": "Relatorio gerencial",
				"description": "Esta seção fornece informações detalhadas sobre os agendamentos, incluindo dados como o segurado, data e hora da visita, consultor responsável e status do agendamento. Acompanhe e gerencie os agendamentos realizados para garantir que as visitas aos segurados sejam realizadas conforme o planejado e cumpram os objetivos estabelecidos."
			},
		};
	},
	methods: {
		async fetchAgendadores() {
			this.loading = true;
			const agendamentoRepo = new GruposRepository();
			try {
				const response = await agendamentoRepo.getGroupMembers(
					this.onlineUser.token, this.agendadoresPage
				);
				if (response.status === 200) {
					this.agendadores = response.data;
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false;
			}
		},
		async fetchAgendamentos() {
			this.loading = true;
			const agendamentoRepo = new AgendamentosRepository();
			try {
				const response = await agendamentoRepo.getAgendamentosGerencial(
					this.filters,
					this.onlineUser.token,
					this.gerencialPage
				);
				if (response.status === 200) {
					const data = response.data.agendamentos.data;
					this.agendamentos = data;
					this.stats = response.data.estatisticas;

					// Atualizar gráfico
					this.updateChart(response.data.estatisticas.total_por_agendador);
				}
			} catch (error) {
				handleUnauthorized(error);
			} finally {
				this.loading = false;
			}
		},
		updateChart(totalPorAgendador) {
			this.loading = true;
			const categories = totalPorAgendador.map((item) => item.agendador_email);
			const seriesData = totalPorAgendador.map((item) => item.total);

			// Atualiza as categorias do eixo X
			this.chartOptions.xaxis.categories = categories;

			// Atualiza os dados e o nome da série
			this.chartSeries[0].data = seriesData;

			// Verifica se há apenas um agendador e atualiza o nome da série
			if (categories.length === 1) {
				this.chartSeries[0].name = `Agendamentos de ${categories[0]}`;
			} else {
				this.chartSeries[0].name = "Agendamentos por Agendador";
			}
			this.loading = false;
		},
	},
	created() {
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.fetchAgendadores();
		this.fetchAgendamentos();
	}
};
</script>

<style scoped>
.stat-card {
	background: #f5f5f5;
	padding: 1rem;
	border-radius: 8px;
	text-align: center;
}

.stat-card h2 {
	font-size: 1.25rem;
	color: #333;
}

.stat-card p {
	font-size: 2rem;
	font-weight: bold;
}

.input {
	margin: 0.5rem 0;
	padding: 0.5rem;
	border: 1px solid #ccc;
	border-radius: 4px;
	width: 100%;
}

.btn-primary {
	background-color: #4caf50;
	color: white;
	padding: 0.5rem 1rem;
	border: none;
	border-radius: 4px;
	cursor: pointer;
}
</style>